<!--  -->
<template>
  <div class=''>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>新闻</span>
          </div>

          <div class='content'>
            <div class="Item-add">
              <a @click="startEditNews()">- 添加新闻 -</a>
            </div>

            <div class="newWrap"
                 v-for="(item ,index) in allNews">
              <div class="timeWrap">
                <p>{{formatDate(item.newsDate,'yyyy年MM月dd日')}}</p>
              </div>
              <div class="contentWrap">
                <div class="newsItemTitle">
                  <!-- <router-link to="/news"> -->
                  <h1>
                    {{item.newsTitle}}
                  </h1>
                  <!-- </router-link> -->
                  <div>
                    <a @click="startEditNews(item)">编辑</a>
                    <a @click="delNews(item)">删除</a>
                  </div>
                </div>
                <div class="newsItemContent">
                  {{item.newsHtml}}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :title="isEdit?'编辑新闻':'新增新闻'"
               :visible.sync="editNewsDialogVisible"
               width="1070px">

      <el-row :gutter="20"
              style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="4"
                style="text-align: right;">
          新闻标题
        </el-col>
        <el-col :span="9">
          <el-input placeholder="请输入内容"
                    clearable
                    v-model="editNewsData.news.newsTitle">
          </el-input>
        </el-col>
        <el-col :span="4"
                style="text-align: right;">
          发生时间
        </el-col>
        <el-col :span="5">
          <el-date-picker v-model="editNewsData.news.newsDate"
                          align="right"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-col>
      </el-row>
      产品详情
      <editor :api-key="editorConf.kkey"
              :init="editorConf"
              v-model="editNewsData.content"></editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editNewsDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="editNews">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

var Editor = require("@tinymce/tinymce-vue").default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    editor: Editor // <- Important part
  },
  data() {
    //这里存放数据
    return {
      isEdit: false,
      allNews: [],
      editNewsData: {
        news: {},
        content: ""
      },
      newsContent: "",
      editNewsDialogVisible: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    delNews(news) {
      var that = this;
      this.$alert("是否删除该新闻", "提示", {
        confirmButtonText: "确定",
        callback: action => {
          if (action == "confirm") {
            this.$request.post({
              url: "/api/admin/news/delNews",
              params: news,
              callback: {
                success: function(data) {
                  that.allNews = data.data;
                },
                err: function(err) {
                  console.log(err);
                }
              }
            });
          }
        }
      });
    },
    startEditNews(news) {
      if (news === undefined) {
        this.isEdit = false;
        this.editNewsDialogVisible = true;
        this.editNewsData = { news: {}, content: "" };
      } else {
        this.isEdit = true;
        var that = this;
        var editNewsData = {
          news: JSON.parse(JSON.stringify(news)),
          content: ""
        };
        this.$request.get({
          url: "/api/pageData/news/content",
          params: { id: editNewsData.news.newsId },
          callback: {
            success: function(data) {
              editNewsData.content = data.data.content;
              that.editNewsData = editNewsData;
              that.editNewsDialogVisible = true;
            },
            err: function(err) {
              console.log(err);
            }
          }
        });
      }
    },
    editNews() {
      var url = "";
      var that = this;
      var url = "";
      if (this.isEdit) {
        url = "/api/admin/news/editNews";
      } else {
        url = "/api/admin/news/addNews";
      }
      this.$request.post({
        url: url,
        params: that.editNewsData,
        callback: {
          success: function(data) {
            that.editNewsDialogVisible = false;
            that.editNewsData = {
              news: {},
              content: ""
            };
            that.allNews = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    formatDate(longTypeDate, fmt) {
      var date = new Date();
      date.setTime(longTypeDate);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.$request.get({
      url: "/api/pageData/admin/news",
      callback: {
        success: function(data) {
          that.allNews = data.data;
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.newsItemTitle {
  display: flex;
  position: relative;
}

.newsItemTitle h1 {
  font-size: 105%;
  color: #314478;
  line-height: 1.3;
  padding: 0 0 10px 0;
  text-align: left;
  text-indent: -1.1em;
  padding-left: 1.1em;
  font-weight: bold;
}

.newsItemTitle div {
  position: absolute;
  right: 0;
}

.newsItemTitle a {
  color: cornflowerblue;
  font-size: 90%;
  margin-right: 10px;
  cursor: pointer;
}

.newWrap {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 2em;
}

.timeWrap p {
  width: 150px;
  text-align: center;
  vertical-align: middle;
  padding: 0;
  font-size: 95%;
  background: #b0bec5;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  line-height: 1.4;
}

.contentWrap {
  width: calc(100% - 170px);
}
</style>